import { profileWorkingDirectorySchema } from "../protocol/profile.js";
import { agentControllerConversationRefSchema } from "./conversation-contract.js";
import { conversationBootstrapReasonSchema } from "./conversation-lifecycle.js";
import * as z$1 from "zod/v4";
//#region src/schemas/daemon/conversation-execution-state.ts
const ISO_DATE_TIME_SCHEMA = z$1.iso.datetime({ offset: true });
const bootstrapTemplateFactsSchema = z$1.strictObject({
	templateVersion: z$1.string().min(1),
	contentFingerprint: z$1.string().min(1)
});
const conversationExecutionStateSchema = z$1.strictObject({
	agentContextLookupKey: z$1.string().min(1),
	activeContextId: z$1.string().min(1).nullable(),
	lastResolvedAgentControllerConversation: agentControllerConversationRefSchema.optional(),
	lastRuntimeWorkspacePath: profileWorkingDirectorySchema.optional(),
	runtimeWorkspaceFingerprint: z$1.string().min(1),
	bootstrapLastAppliedAt: ISO_DATE_TIME_SCHEMA.optional(),
	bootstrapLastActivatedAt: ISO_DATE_TIME_SCHEMA.optional(),
	dispatchesSinceBootstrapApplied: z$1.number().int().min(0),
	lastAppliedTemplateVersion: z$1.string().min(1).optional(),
	lastAppliedContentFingerprint: z$1.string().min(1).optional(),
	pendingBootstrapReason: conversationBootstrapReasonSchema.optional(),
	updatedAt: ISO_DATE_TIME_SCHEMA
});
//#endregion
export { bootstrapTemplateFactsSchema, conversationExecutionStateSchema };

//# sourceMappingURL=conversation-execution-state.js.map